module.exports = __webpack_public_path__ + "img/logo.a702a29d.png";